(ns manatee.ui.handlers
  (:require #?@(:cljs [[re-pressed.core]])
            [manatee.annotation.handlers :as annotation]
            [manatee.auth.token :as token]
            [manatee.components.notifications.handlers :as notifications]
            [manatee.fx.local-storage :as local-storage]
            [manatee.ui.app-db :as db]
            [manatee.user.app-db :as user-db]
            [manatee.user.handlers :as user]
            [re-frame.core :as rf]))

;; this catches an error where some users'
;; auth-token cookies have been set to "null"
(defn- remove-null-string
  [auth-token]
  (when (not= "null" auth-token)
    auth-token))

(rf/reg-event-db
 ::toggle-menu
 (fn toggle-menu
   [db [_]]
   (db/set-toggle-menu db)))

(rf/reg-event-fx
 ::init-app
 [(rf/inject-cofx :cookie/get [:auth-token])
  (rf/inject-cofx ::local-storage/get-value :dev-mode?)]
 (fn init-app
   [{{:keys [auth-token]} :cookie/get _dev-mode? ::local-storage/get-value :keys [db]} [_ config]]
   (let [{:keys [sentry]} config
         auth-token (remove-null-string auth-token)]
     (cond-> {:dispatch-n
              ;; have to give full ns for some reason
              [#?(:cljs [:re-pressed.core/add-keyboard-event-listener "keydown"])
               [::notifications/load-announcements]]}
       (:active? sentry) (update :dispatch-n conj [:bedrock-ui.sentry.handlers/init config])
       auth-token (update :dispatch-n concat [[::user/load-user auth-token]
                                              [::annotation/load-task-configs]
                                              [::notifications/show-announcements false]])
       (not auth-token) (update :dispatch-n concat [[::notifications/show-announcements true]])
       auth-token (assoc :db (user-db/set-user db {:id (:id (:sub (token/peek auth-token)))}))))))
